<template>
  <div class="one-news-read">
    <readLayout>
      <h2>
        {{ $store.getters.oneNews.title }}
      </h2>
      <p class="date-in-title">{{ $store.getters.oneNews.released_at }}</p>
      <textarea
        ref="textarea"
        v-html="$store.getters.oneNews.content"
      ></textarea>
      <div>
        <p>附件</p>
        <ul v-if="$store.getters.oneNews.files.length > 0">
          <li
            v-for="(file, index) in $store.getters.oneNews.files"
            :key="index"
          >
            <a :href="file.url" target="_blank" :download="file.name">{{
              file.name
            }}</a>
          </li>
        </ul>
      </div>
    </readLayout>
  </div>
</template>

<script>
import readLayout from "@/layout/ReadLayout.vue";
export default {
  components: {
    readLayout
  },
  mounted() {
    this.$refs.textarea.style.height = this.$refs.textarea.scrollHeight + "px";
  }
};
</script>

<style lang="scss" scoped>
.one-news-read {
  textarea {
    width: 100%;
    border: none;
  }
}
</style>
